import React from "react";
import moment from "moment";
import { Badge, Card, Table } from "react-bootstrap";

const Obvestila = (props: any) => {
  const { alerts, ...rest } = props;
  const currencyFormatter = new Intl.NumberFormat("sl-SI", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  });

  return (
    <Card className="flex-fill w-100">
      <Card.Header>
        <Card.Title className="mb-0">Obvestila</Card.Title>
      </Card.Header>
      <Table striped className="my-0">
        <thead>
          <tr>
            <th>Znamka</th>
            <th>Model</th>
            <th className="d-none d-xl-table-cell">Opis</th>
            <th className="d-none d-xl-table-cell">Letnik</th>
            <th>Cena</th>
            <th>Poslano</th>
          </tr>
        </thead>
        <tbody>
          {alerts.map((alert: any, i: number) => {
            return (
              <tr key={i}>
                <td>{alert.ad.make}</td>
                <td>{alert.ad.model}</td>
                <td className="d-none d-xl-table-cell">{alert.ad.title}</td>
                <td className="d-none d-xl-table-cell">{alert.ad.year}</td>
                <td>{currencyFormatter.format(alert.ad.latestPrice)}</td>
                <td>{moment(alert.createdAt).fromNow()}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Card>
  );
};

export default Obvestila;
